let DropSelect = require('sma.admin/components/dropdowns/dropselect')

let selectTempl = require('sma.admin/components/dropdowns/partials/dropselectextendable.mustache')
let itemsTempl = require('sma.admin/components/dropdowns/partials/items.mustache')
let itemsExtendedTempl = require('sma.admin/components/dropdowns/partials/itemsextended.mustache')

class DropSelectExtendable extends DropSelect {
	get events () {
		return {
			'click .sma-js-dropselect-done': 'handleDone',
			'click .sma-js-dropselect-cancel': 'handleCancel',
			'click .sma-js-action-item': 'selectItem',
			'change .dropdown-item input[type="checkbox"]': 'itemChanged',
			'hide.bs.dropdown': 'hideDropdown',
			'shown.bs.dropdown': 'getItems',
			'click .sma-js-select-parent': 'showExtraColumns',
			'click .sma-js-select-back': 'showItems',
		};
	}

	initialize (options) {
		$(document).on('click', '.sma-dropselect, .sma-dropselect .dropdown-item', function (e) {
			e.stopPropagation();
		});

		this.extraItems = options.extraItems;
		this.setItems(options.items);

		this.onDone = options.onDone || function () {return;};

		this.title = options.title;

		this.render();

		if (this.$selectEl) {
			this.$selectEl.after(this.$el);
		}
	}

	hideDropdown(e) {
		return false
	}

	renderItems () {
		this.$items = this.$el.find('.sma-dropselect-items');
		this.$items.empty();

		let context = {
			items: this.items,
			checkboxes: true,
			extraItems: this.extraItems,
		};

		this.$items.append(itemsTempl(context));

		if (this.$selectEl) {
			this.selectItemFromSelect();
		}
	}

	renderExtraItems () {
		this.$extraItems = this.$el.find('.sma-dropselect-extra-items');
		this.$extraItems.empty();

		let items = {
			extraItems: this.extraItems,
		};

		this.$extraItems.append(itemsExtendedTempl(items));
	}

	renderContents () {
		this.renderItems();
		this.renderExtraItems();
	}

	render () {

		this._el = selectTempl({
			title: this.title,
			cancel: gettext('Cancel'),
			done: gettext('Done'),
		});

		this.setElement(this._el);

		this.renderContents();

		if (this.$selectEl) {
			this.$selectEl.hide();
		}
	}

	showExtraColumns(e) {
		e.preventDefault();

		let key = $(e.currentTarget).attr('data-key')
		this.currentEl = $("#" + key)
		this.currentEl.show();

		this.$items.hide();
	}

	showItems(e) {
		this.currentEl.hide();
		this.$items.show()
	}

	get displayedItems () {
		var items = [];

		_.each(this.$items.children(), item => {
			let $item = $(item).find('input');

			items.push({
				name: $item.attr('name'),
				text: $item.parent().text(),
				checked: $item.is(':checked'),
			});

		});

		_.each(this.$extraItems.children(), extraItem => {
			let $itemList = $(extraItem).find('input');

			_.each($itemList, item => {
				let $item = $(item)
				items.push({
					name: $item.attr('name'),
					text: $item.parent().text(),
					checked: $item.is(':checked'),
				});
			})

		});


		return items;
	}

	handleDone () {
		this.updateChangedItems();
		this.onDone(this.changedItems);
		this.$el.removeClass('show');
		return false;
	}

}

module.exports = DropSelectExtendable
